<template>
  <div id = "sketch-scope-m">
  <v-container fluid>
    <core-app-view />
      <v-row >
        <v-col cols="12">
          <v-sheet
              class="mx-auto"
              dark
              color="#263238"
              height="25vh"
          >
            <v-row style="padding-top: 4vh" class="fill-height" align="center" align-content="center" justify="center">
              <v-col cols="12" class="text-center">
                <h5 class="display-1 font-weight-thin">{{ss.title}}</h5>
                <h3 class="font-weight-bold">Demos & Requires</h3>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>
      
        <v-col class="left" cols="12">
          <v-row
              style="padding-left: 3vw; padding-right: 3vw"
              align="center"
              justify="center">
            <v-col
                class="text-start"
                cols="12">
              <v-row class="fill-height" align="center" justify="start">
              </v-row>
              <v-row align="center" justify="start">
                <v-col class="text-start" cols="12">
                  <h1 class="display-1 font-weight-thin">
                    개요
                  </h1>
                </v-col>
                <v-col cols="4" style="margin-left: 50vw" >
                  <v-btn plain large color="primary">
                    <v-icon small>{{icons.mdiEmailSendOutline}}</v-icon>
                    <a :href="link1">
                      <h3 style="margin-left: 5px;">Request</h3>
                    </a>
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-img
                      src='@/assets/sketchscope.png'
                      class="video"
                      max-width="100%"
                  ></v-img>
                </v-col>
                <v-divider light vertical inset/>
                <v-col cols="12">
                  <body>
                  <div v-html="ss.about.split('\n').join('<br />')"></div>
                  </body>
                  <body>
                  <a :href="ss.paperlink">
                    논문 링크
                  </a>
                  </body>
                  <div v-html="about_add.split('\n').join('<br />')"></div>
                </v-col>

              </v-row>
              </v-col>
            </v-row>
        </v-col>

            <v-row style="padding-top: 10vh;"  align="center" justify="start">
              <v-col class="left" cols="12">
                  <v-row class="fill-height" align="center" justify="start">
                 <v-col class="text-start" cols="12">
                  <h2 class="display-1 font-weight-thin">
                    Concepts
                  </h2>
                </v-col>
                <v-divider light vertical inset/>
                <v-col cols="12">
                  <body>
                  <div v-html="ss.updates.split('\n').join('<br />')"></div>

                  <video controls width=100% style = "margin-top:5vh; margin-bottom:10vh">

                    <source src="@/assets/sketchscope_basic.mp4"
                            type="video/mp4">

                    Sorry, your browser doesn't support embedded videos.
                  </video>
                  </body>
                </v-col>

              </v-row>
                  <h2 class="display-1 font-weight-thin">
                    For Developer
                  </h2>
                  <v-row style="padding-top: 5vh; margin-left:1vw; margin-right:2vw">
                  <body class="left">
                 <div v-html="develop.split('\n').join('<br />')"></div>
                 </body>
                 <video controls width=100% style = "margin-top:5vh; margin-bottom:2vh; margin-right: 2vw;">

                    <source src="@/assets/SketchScope_Asset.mp4"
                            type="video/mp4">

                    Sorry, your browser doesn't support embedded videos.
                  </video>
                 </v-row>
                </v-col>
                <v-divider light vertical inset/>
            </v-row>

            <v-col cols="12">
              
            </v-col>

            <v-row style="padding-top: 10vh;" align="left" justify="start" >
                <v-col class="left" cols="12">
                  <h2 class="display-1 font-weight-thin">
                    Application
                  </h2>
                  <v-row style="padding-top: 5vh; margin-left:1vw; margin-right:2vw" >
                  <body class = "left">
                 <div v-html="app.split('\n').join('<br />')"></div>
                 </body>
                 </v-row>
                </v-col>
                <v-divider light vertical inset/>
            </v-row>

            <v-col cols="12">
              <v-img
                      class = "video"
                      src='../../assets/sm_app.png'
                      max-width="1000"
                  ></v-img>
      </v-col>

      <core-footer />
    </v-container>
  </div>
  
</template>


<script>
import {ss} from '../../data/sketchscope.js'
import {mdiEmailSendOutline, mdiArrowUp} from '@mdi/js'

export default {
  name: 'SketchScopeM',
  components: {
                CoreFooter: () => import ('@/components/mobile/core/Footer'),
                CoreAppView: () => import('@/components/mobile/core/AppView')
                },
  data: () => ({
    ss,
    develop: "개발자를 위한 Unity Asset은 여러 Scene을 만들어 각 과정이 어떠한 방식으로 진행되는지 이해하기 쉽게 하였습니다. \n" +
            "각 Scene에 대한 설명을 아래 영상에서 확인해 보세요. \n",
    app: "전시 환경, 보유하고 있는 장비, 전시 주제 등 서로 다른 과학관과 박물관의 다양한 환경에 SketchScope을 적용할 수 있도록 하였습니다. \n" +
            "현재 개발이 완료되어 활용할 수 있는 장비는 Leap Motion과 HoloLense 2가 있습니다. \n" +
            "자세한 설명은 상단의 Motion Recognition, AR: Augmented Reality 탭을 참고해 주세요. \n",
    icons: {
      mdiEmailSendOutline, mdiArrowUp
    },
    link1: "https://forms.gle/R2m661HLwxYQeLta9",
    publicPath: process.env.BASE_URL,
    imgPath: '../assets/sketchscope.png',
    about_add: "\n\n",
  }),
}
</script>


<style>
.center {
  margin-left: 3vw;
  margin-right: 3vw;
}
.left {
  margin-left: 0.5vw;
  margin-right: 0.5vw;
}

</style>